import { render } from "./Rapportini.vue?vue&type=template&id=9358b5cc&scoped=true&ts=true"
import script from "./Rapportini.vue?vue&type=script&lang=ts"
export * from "./Rapportini.vue?vue&type=script&lang=ts"

import "./Rapportini.vue?vue&type=style&index=0&id=9358b5cc&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_apib/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9358b5cc"]])

export default __exports__